export interface PickingDiffBatch {
  batchId: number
  batchNumber: string
  expirationDate: string
}

export class PickingDiff {
  public positionId: number = 0
  public positionName: string = ''
  public typePickingRouteMovementId: number = 0
  public realQty: number = 0
  public pickedQty: number = 0
  public stockQty: number = 0
  public pickedAdjustmentQty: number = 0
  public stockAdjustmentQty: number = 0
  public differenceQty: number = 0
  public reductionQty: number = 0
  public reservedQty: number = 0
  public commercialRejectiontQty: number = 0
  public batch?: PickingDiffBatch | null = null

  public isRoutePosition(): boolean {
    return this.typePickingRouteMovementId === 1
  }

  public pendingQty(): number {
    return this.realQty - this.adjustedPickedQty()
  }

  public adjustedStockQty(): number {
    return this.stockQty + this.stockAdjustmentQty
  }

  public adjustedPickedQty(): number {
    return this.pickedQty + this.pickedAdjustmentQty
  }

  public adjustedReductionQty(): number {
    return this.reductionQty + this.pickedAdjustmentQty
  }

  public adjustedReservedQty(): number {
    return this.reservedQty + this.pickedAdjustmentQty
  }

  public adjustedcommercialRejectiontQty(): number {
    return this.commercialRejectiontQty + this.pickedAdjustmentQty
  }

  public signedValueLabel(adjustment: number): string {
    if (adjustment > 0) {
      return `+${adjustment}`
    }
    return `${adjustment}`
  }

  public quantityLabel(value: number, adjustment: number): string {
    let label = ''
    if (adjustment > 0) label = `${value} (+${adjustment})`
    else if (adjustment < 0) label = `${value} (${adjustment})`
    else label = `${value}`
    return label
  }

  public pickedLabel(): string {
    return this.quantityLabel(this.pickedQty, this.pickedAdjustmentQty)
  }

  public stockLabel(): string {
    return this.quantityLabel(this.stockQty, this.stockAdjustmentQty)
  }

  public differenceLabel(): string {
    return this.signedValueLabel(this.differenceQty)
  }

  public reductionLabel(): string {
    return this.signedValueLabel(this.reductionQty)
  }

  public reservedLabel(): string {
    return this.signedValueLabel(this.reservedQty)
  }

  public pendingLabel(): string {
    return this.signedValueLabel(this.pendingQty())
  }

  public commercialRejectionLabel(): string {
    return this.signedValueLabel(this.commercialRejectiontQty)
  }

  public hasChanged(): boolean {
    return (
      this.pickedAdjustmentQty != 0 ||
      this.stockAdjustmentQty != 0 ||
      this.differenceQty != 0 ||
      this.reductionQty != 0 ||
      this.reservedQty != 0 ||
      this.commercialRejectiontQty != 0
    )
  }
}
